/**
 * CTR Collection Products
 * – AJAX tag-pill filtering (no page reload)
 * – Variant pill selection with dynamic price updates
 *
 * Uses event delegation so everything keeps working after AJAX DOM swaps.
 */
(function () {
  /* ===================================================
     1.  TAG-PILL AJAX FILTERING
     =================================================== */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.ctr-cp__tab');
    if (!pill) return;
    e.preventDefault();

    var section = pill.closest('.ctr-collection-products');
    if (!section) return;

    /* Already active — nothing to do */
    if (pill.classList.contains('ctr-cp__tab--active')) return;

    var sectionId = section.dataset.sectionId;
    var collectionUrl = section.dataset.collectionUrl;
    var tag = pill.dataset.tag; /* empty string = "All" */

    /* ── Build target URL ── */
    var newPath = tag ? collectionUrl + '/' + tag : collectionUrl;

    var currentParams = new URLSearchParams(window.location.search);
    var fetchUrl = new URL(newPath, window.location.origin);

    /* Keep existing sort_by */
    if (currentParams.has('sort_by')) {
      fetchUrl.searchParams.set('sort_by', currentParams.get('sort_by'));
    }

    /* section_id tells Shopify to return only this section's HTML */
    fetchUrl.searchParams.set('section_id', sectionId);

    /* ── Update active pill immediately ── */
    section.querySelectorAll('.ctr-cp__tab').forEach(function (t) {
      t.classList.remove('ctr-cp__tab--active');
    });
    pill.classList.add('ctr-cp__tab--active');

    /* ── AJAX fetch ── */
    var container = document.getElementById('ProductGridContainer');
    if (container) {
      container.style.transition = 'opacity .2s ease';
      container.style.opacity = '0.3';
    }

    fetch(fetchUrl.toString())
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newContainer = parsed.getElementById('ProductGridContainer');

        if (container && newContainer) {
          container.innerHTML = newContainer.innerHTML;
        }
        if (container) {
          container.style.opacity = '1';
        }

        /* Update the sort form action so future sorts use the tag-filtered URL */
        var sortForm = section.querySelector('form[is="facet-form"]');
        if (sortForm) {
          sortForm.setAttribute('action', newPath);
        }

        /* Fire custom event so other scripts can react */
        document.dispatchEvent(new CustomEvent('collection:rerendered'));
      })
      .catch(function () {
        if (container) container.style.opacity = '1';
      });

    /* ── Update browser URL (without section_id) ── */
    var historyUrl = new URL(newPath, window.location.origin);
    if (currentParams.has('sort_by')) {
      historyUrl.searchParams.set('sort_by', currentParams.get('sort_by'));
    }
    history.pushState({}, '', historyUrl.toString());
  });

  /* ===================================================
     2.  VARIANT-PILL SELECTION (price / badge updates)
     =================================================== */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.ctr-cp__variant-pill');
    if (!pill) return;

    var container = pill.closest('.ctr-cp__variants');
    if (!container) return;

    /* Update active state */
    container.querySelectorAll('.ctr-cp__variant-pill').forEach(function (p) {
      p.classList.remove('ctr-cp__variant-pill--active');
    });
    pill.classList.add('ctr-cp__variant-pill--active');

    /* Find the parent card */
    var card = pill.closest('.ctr-cp__card');
    if (!card) return;

    var priceEl       = card.querySelector('[data-price]');
    var comparePriceEl = card.querySelector('[data-compare-price]');
    var saveBadgeEl    = card.querySelector('[data-save-badge]');
    var productLink    = card.querySelector('[data-product-link]');

    var price        = pill.dataset.variantPrice;
    var comparePrice = pill.dataset.variantComparePrice;
    var savePercent  = pill.dataset.variantSave;
    var variantUrl   = pill.dataset.variantUrl;

    /* Update price */
    if (priceEl) priceEl.textContent = price;

    /* Update compare price & save badge */
    if (comparePrice) {
      if (comparePriceEl) {
        comparePriceEl.innerHTML = '<s>' + comparePrice + '</s>';
        comparePriceEl.style.display = '';
      }
      if (saveBadgeEl) {
        saveBadgeEl.textContent = 'Save ' + savePercent + '%';
        saveBadgeEl.style.display = '';
      }
    } else {
      if (comparePriceEl) comparePriceEl.style.display = 'none';
      if (saveBadgeEl)    saveBadgeEl.style.display = 'none';
    }

    /* Update product link to include variant */
    if (productLink && variantUrl) {
      productLink.href = variantUrl;
    }
  });
})();
